import { HelpOutline } from '@mui/icons-material'
import type { StackProps } from '@mui/material'
import { Stack, Tooltip } from '@mui/material'
import React from 'react'

import CustomTypography from '@/components/dataDisplay/CustomTypography'

type ConfigFieldProps = Omit<StackProps, 'flexDirection' | 'gap'> & {
  children: React.ReactNode
  helpTooltip?: string
  label: string
}

export function ConfigField({ children, helpTooltip, label, ...stackProps }: Readonly<ConfigFieldProps>) {
  return (
    <Stack {...stackProps} flexDirection="column" gap={1}>
      <Stack direction="row" spacing={1}>
        <CustomTypography variant="h3">{label}</CustomTypography>
        {helpTooltip && (
          <Tooltip title={helpTooltip}>
            <HelpOutline fontSize="small" sx={{ color: 'grey.500' }} />
          </Tooltip>
        )}
      </Stack>
      {children}
    </Stack>
  )
}
